import React, { useCallback, useMemo, useContext, useEffect, useState } from 'react';
import PageWrapper from '../../../../layout/PageWrapper/PageWrapper';
import SubHeader, { SubHeaderLeft, SubHeaderRight } from '../../../../layout/SubHeader/SubHeader';
import Page from '../../../../layout/Page/Page';
import Breadcrumb from '../../../../components/bootstrap/Breadcrumb';
import { demoPages } from '../../../../menu';
import { DefaultContext } from '../../../../contexts/default';
import Card, { CardBody } from '../../../../components/bootstrap/Card';
import Button from '../../../../components/bootstrap/Button';
import TableCustom from '../../../../components/MyCustom/TableCustom';
import SelectEstablishment from '../../../../components/MyCustom/SelectEstablishment';
import SelectStore from '../../../../components/MyCustom/SelectStore';
import Input from '../../../../components/bootstrap/forms/Input';
import BtnLoad from '../../../../components/MyCustom/BtnLoad';
import ModalRegisterStoreComplements from '../../../../components/modals/StoreComplements/ModalRegister'
import ModalPriceUpdatePreview from '../../../../components/modals/Products/ModalPriceUpdatePreview';
import useDarkMode from '../../../../hooks/useDarkMode';
import Money from '../../../../helpers/utils/money/money';
import ComplementDB from '../../../../database/wrappers/complement';
import StoreComplementDB from '../../../../database/wrappers/storeComplement';
import { orderBy } from 'firebase/firestore';
import logo from '../../../../assets/img/logo_uget_black.png'
import UserHistory from '../../../../database/wrappers/userHistory';
import useStoreComplementPriceImport from './hooks/useStoreComplementPriceImport';
const StoreComplements = () => {
  const { darkModeStatus } = useDarkMode();

  const { establishment, store, onShowAlert, settings, user } = useContext(DefaultContext)
  const [complements, setcomplements] = useState(null)
  const [storecomplementsDicionary, setstorecomplementsDicionary] = useState(null)
  const [complementsRender, setcomplementsRender] = useState([])
  const [complementselected, setcomplementselected] = useState(null);
  const [showModal, setshowModal] = useState(false);
  const {
    inputPriceFile,
    loadImportPrices,
    savingPrices,
    openPricePreviewModal,
    pricePreviewRows,
    invalidPriceRows,
    setOpenPricePreviewModal,
    handleClickImportPrices,
    handleImportPriceFile,
    handleConfirmPriceUpdate,
    handleClosePricePreviewModal,
  } = useStoreComplementPriceImport({
    establishmentId: establishment ? establishment.id : null,
    storeId: store ? store.id : null,
    complements: complementsRender,
    onShowAlert,
  });

  useEffect(() => {
    if (!establishment) return;
    const onSubscribe = new ComplementDB(establishment.id).on(setcomplements, orderBy('name', 'asc'));
    return onSubscribe
  }, [establishment])

  useEffect(() => {
    if (!establishment || !store) return;
    const onSubscribe = new StoreComplementDB(establishment.id, store.id).on(datas => {
      const dicionary = {};
      datas.forEach(data => dicionary[data.id] = data)
      setstorecomplementsDicionary(dicionary)
    });
    return onSubscribe;
  }, [establishment, store])

  useEffect(() => {
    if (complements !== null && storecomplementsDicionary !== null) {
      const complementsRender = complements.map(product => {
        const storeProd = storecomplementsDicionary[product.id];
        return {
          ...product,
          ...storeProd,
          fiscal_data: storeProd?.fiscal_data ? storeProd?.fiscal_data : product?.fiscal_data,
          defaultPrice: product.price,
          active: !storeProd ? true : storeProd.active,
          storeProdExist: !!storeProd,
          ifoodPrice: storeProd?.ifoodPrice || storeProd?.price || product?.price,
          rappiPrice: storeProd?.rappiPrice || storeProd?.price || product?.price
        }
      })

      setcomplementsRender(complementsRender);
    }
  }, [complements, storecomplementsDicionary])

  const handleOpenModalEdit = useCallback((item) => {
    setcomplementselected(item)
    setshowModal(true)
  }, [])

  const handleChangeStatus = useCallback((id, item) => {
    const onSuccess = () => { };
    const onError = () => {
      onShowAlert({
        title: 'ERRO!',
        msm: 'Não foi possível atualizar o status do produto',
        icon: 'Error',
        color: 'danger'
      })
    };
    if (item.storeProdExist) {
      new StoreComplementDB(establishment.id, store.id)
        .update(item.id, {
          active: !item.active
        })
        .then(() => {
          onSuccess()
          new UserHistory(establishment.id, user, "o Complemento", store.name)
            .update(item.id, { data: { active: !item.active }, selected: item })
            .finally(() => { })
        })
        .catch(onError)
    } else {
      new StoreComplementDB(establishment.id, store.id)
        .define(item.id, {
          active: !item.active
        })
        .then(() => {
          onSuccess()
          new UserHistory(establishment.id, user, "o Complemento", store.name)
            .update(item.id, { data: { active: !item.active }, selected: item })
            .finally(() => { })
        })
        .catch(onError)
    }
  }, [establishment, store])

  const columns = useMemo(() => ([
    {
      label: 'Imagem',
      field: 'image_url',
      format: row => (
        <>
          {row.image_url ? (
            <img src={row.image_url} alt="Imagem" width={54} height={54} />
          ) : (
            <img src={logo} alt="Imagem" width={60} height='auto' />
          )}
        </>
      ),
      noExport: true
    },
    {
      label: 'Nome',
      field: 'name',
    },
    {
      label: 'Nome Sec.',
      field: 'secondName',
      hidden: !settings?.ecommerce,
      noExport: !settings?.ecommerce
    },
    {
      label: 'Sku',
      field: 'sku',
      hidden: !settings?.ecommerce,
      noExport: !settings?.ecommerce
    },
    {
      label: 'Preço Padrão',
      field: 'defaultPrice',
      format: row => Money.centsToMaskMoney(row.defaultPrice),
      isCurrency: true
    },
    {
      label: 'Preço Na Loja',
      field: 'price',
      format: row => Money.centsToMaskMoney(row.price),
      isCurrency: true
    },
    {
      label: 'Preço No Ifood',
      field: 'ifoodPrice',
      format: row => Money.centsToMaskMoney(row?.ifoodPrice ?? 0),
      isCurrency: true
    },
    {
      label: 'Preço Na Rappi',
      field: 'rappiPrice',
      format: row => Money.centsToMaskMoney(row?.rappiPrice ?? 0),
      isCurrency: true
    },
    {
      label: 'Status',
      field: '{row}',
      format: row => (
        <>
          <Button
            isLink
            color={row.active ? 'success' : 'danger'}
            icon='Circle'
            onClick={() => handleChangeStatus(row.id, row)}
            className='text-nowrap'>
            {row.active ? 'Ativo' : 'Inativo'}
          </Button>
        </>
      ),
      formatExport: row => row.active ? 'Ativo' : 'Inativo'
    },
    {
      label: 'Ações',
      field: 'actions',
      format: row => (
        <div className='w-50 d-flex justify-content-between'>
          <Button
            color={darkModeStatus ? 'light' : 'dark'}
            icon="edit"
            hoverShadow="sm"
            size="sm"
            text=''
            onClick={() => handleOpenModalEdit(row)}
          />
        </div>
      ),
      noExport: true
    },
  ]), [handleChangeStatus, handleOpenModalEdit])

  return (
    <>
      <PageWrapper title={demoPages.pdvLoja.subMenu.complement.text}>
        <SubHeader>
          <SubHeaderLeft>
            <Breadcrumb
              list={[
                { title: 'PDV Loja', to: '/pdvLoja' },
                { title: 'Complementos na Loja', to: '/pdvLoja/complements' },
              ]}
            />
          </SubHeaderLeft>
          <SubHeaderRight>
            <Input
              hidden
              id='input-file-import-store-complement-price-xlsx'
              type='file'
              accept={'.xlsx'}
              ref={inputPriceFile}
              onChange={handleImportPriceFile}
            />
            {loadImportPrices ? (
              <BtnLoad />
            ) : (
              <Button
                type='file'
                className='text-dark'
                color='success'
                icon='upload'
                shadow='sm'
                hoverShadow='sm'
                onClick={handleClickImportPrices}>
                Importar Preços
              </Button>
            )}
          </SubHeaderRight>
        </SubHeader>
        <Page container='fluid'>
          <Card>
            <CardBody className='table-responsive p-5'>
              <div className='row d-flex align-items-center mt-4 mx-1' >
                <SelectEstablishment />
                <SelectStore />
              </div>
              <TableCustom columns={columns} rows={complementsRender} fileName={'Complementos-na-loja'} />
            </CardBody>
          </Card>
        </Page>
      </PageWrapper>

      <ModalRegisterStoreComplements
        open={showModal}
        setIsOpen={setshowModal}
        setIsClose={() => setshowModal(false)}
        complementtSelected={complementselected}
      />
      <ModalPriceUpdatePreview
        open={openPricePreviewModal}
        setIsOpen={setOpenPricePreviewModal}
        setIsClose={handleClosePricePreviewModal}
        rows={pricePreviewRows}
        invalidRows={invalidPriceRows}
        onConfirm={handleConfirmPriceUpdate}
        loading={savingPrices}
      />
    </>
  );
};

export default StoreComplements;
